import { swSettings } from "app/common/services/swSettings";
import { PLAYERS_STATE } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/table-top/const";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export interface INavigateToPlayers {
    marketId?: string;
    marketName?: string;
    country?: number;
}

export const navigateToPlayers = ({ marketId, marketName, country }: INavigateToPlayers) => {
    const { returnToState } = proNavigator.getParams();
    const market =
        UserCustomCategoryService.getCustomCategoryById(marketId) ||
        UserCustomCategoryService.getCustomCategoryByName(marketName);
    const targetState = PLAYERS_STATE;
    const { forUrl } = market;
    const state = returnToState ? returnToState : targetState;
    const stateObj = proNavigator.getState(state);
    const configId = proNavigator.getConfigId(stateObj);
    const { defaultParams } = swSettings.components[configId];

    void proNavigator.go(state, {
        ...defaultParams,
        category: forUrl,
        webSource: devicesTypes.TOTAL,
        country: country ? country : defaultParams.country,
        ignoreFilterConsistency: true,
    });
};
